import React from 'react';
import {ProgressSpinner} from "primereact/progressspinner";
import {useTranslate} from "../useTranslate";

function DatatableEmptyMessage({loading}) {
    const translate = useTranslate()
    return (
        <div className="text-center text-xs">{!loading?<span>{translate("datatable-empty-message")}</span>:<div className="flex gap-2 align-items-center w-fit"><ProgressSpinner strokeWidth="4" className="w-2rem h-2rem"/><span>{translate("datatable-loading")}</span></div>}</div>
    );
}

export default DatatableEmptyMessage;